import React, { useEffect, useState } from "react";
import { CenikItem } from "../../../ts/Cenik";
import "./Cenik.scss";
import { CenikInputs } from "./CenikInputs";
import { CenikPolozky } from "./CenikPolozky";
import { Box } from "@mui/material";

export type TCenikQuery = {
  query: string;
  kod: string;
  sirka: string;
  vyska: string;
};

interface Props {
  rowClickHandler?(row: CenikItem): void;
}

const Cenik: React.FC<Props> = ({ rowClickHandler }: Props) => {
  const [cenikQuery, setCenikQuery] = useState<TCenikQuery | null>(null);

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <Box
      className="cenik"
      sx={{
        width: "100%",
        margin: rowClickHandler ? 0 : undefined,
      }}
    >
      {rowClickHandler ? null : <div className="cenikTitle">Cenník</div>}
      <CenikInputs setCenikQuery={setCenikQuery} cenikQuery={cenikQuery} />
      <CenikPolozky cenikQuery={cenikQuery} onSelectRow={rowClickHandler} />
    </Box>
  );
};

export default Cenik;
